// extracted by mini-css-extract-plugin
export default {"row":"Table_row__vg-qa","selectedRow":"Table_selectedRow__LrZCc","text":"Table_text__dRjU+"};